import React, { useContext, useEffect } from "react";
// import TextField from "@mui/material/TextField";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Box,
  Divider,
  Grid,
  Typography,
  // InputLabel,
  // NativeSelect,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

// import InputLabel from '@mui/material/InputLabel';
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import useHttp from "../../hooks/use-http";
import CustomNumberInput from "../form/NumberInput/custom-number-input";
import SeatsContext from "../../store/seats/seats-context";


/*****************note: if any price change will impact the old revewal upgrade ************/
const priceBandList: {
  plan: number;
  planStart: number;
  price: number;
  description: string;
}[] = [
  { plan: 19, planStart: 11, price: 12, description: "10-19 slab" },
  { plan: 39, planStart: 20, price: 10, description: "20-39 slab" },
  { plan: 59, planStart: 40, price: 9, description: "40-59 slab" },
  { plan: 79, planStart: 60, price: 7, description: "60-79 slab" },
  { plan: 100, planStart: 80, price: 6, description: "80-99 slab" },
  { plan: 101, planStart: 101, price: 6, description: "100 plus slab" },
];

const monthDiff = (d1:Date, d2:Date)=> {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}



const Cart = (props: {
  prevSeats: number;
  accountEmail: string | undefined;
  supportFor: string;
  openState: boolean;
  setCartOpenState: (_0: boolean) => void;
  setFormOpenState: (_0: boolean) => void;
}) => {
  const { isLoading, isError, message, sendRequest: paymentgatway } = useHttp();
  const {
    prevSeats,
    accountEmail,
    supportFor,
    openState,
    setCartOpenState,
    setFormOpenState,
  } = props;


  const [subscriptionMonths, setSubscriptionMonths] = React.useState<number>(12);

  const seatsCxt = useContext(SeatsContext);

  const closedMonths = (prevSeats>10 ? monthDiff(new Date(seatsCxt.lastRenewal), new Date) : 0) || 0;
  
  
  const [submitState, setSubmitState] = React.useState(false);
  const [isValid, setIsValid] = React.useState(false);

  const previousPlan: any = priceBandList.find((p) => p.plan >= prevSeats);
  

  const [plan, setPlan] = React.useState<number | undefined>(
    previousPlan?.plan
  );
  
  
  const [seats, setSeats] = React.useState<number>(prevSeats);
  const [userPrice, setUserPrice] = React.useState<number>(0);
  const [totalPrice, setTotalPrice] = React.useState<number>(0);

  const getPaymentResponse = (res: any) => {
    if (res.message.url) window.location.href = res.message.url;
  };

  useEffect(() => {
    setSeats(prevSeats);
    setPlan(previousPlan?.plan);
  }, [prevSeats]);


  const onCheckoutHandler = async (data: any) => {
    let selectedPlan = priceBandList.find((planList) => planList.plan == plan);

    paymentgatway(
      {
        URL: "/api/stripe-payment",
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: {
          type: (prevSeats>10 && seats>prevSeats ? "upgrade" : "new"), //new or upgrade
          price: selectedPlan?.price,
          quantity: (prevSeats>10 && seats>prevSeats ? (seats-prevSeats) : seats),
          account_email: accountEmail,
          totalQuantity: seats,
          monthsCount: (subscriptionMonths-closedMonths) || 12
        },
      },
      getPaymentResponse
    );
  };

  const upgradeSupportHandler = (data: any) => {
    setCartOpenState(false);
    setFormOpenState(true);
  };

  

  const handleClose = () => {
    setCartOpenState(false);
  };

  const handleChange = (event: SelectChangeEvent) => {
    const planInt = parseInt(event.target.value as string);
    if (planInt > seatsCxt.availableSeats) setIsValid(true);
    else setIsValid(false);

    const selectedPlan = priceBandList.find(
      (planList) => planList.plan == planInt
    );

    if (selectedPlan && selectedPlan.planStart>=prevSeats) setSeats(selectedPlan?.planStart);
    setPlan(planInt);

    if (selectedPlan) {
      setUserPrice(selectedPlan?.price * (subscriptionMonths-closedMonths));
      setTotalPrice(selectedPlan?.price * (subscriptionMonths-closedMonths) * planInt);
    }
  };

  const handleChangeSeats = (seat: number) => {
    // console.log("ssss", seat);
    if (seat > seatsCxt.availableSeats) setIsValid(true);
    else setIsValid(false);

    setSeats(seat);

    const selectedPlan = priceBandList.find((p) => p.plan >= seat);

    setPlan(selectedPlan?.plan);
    if (selectedPlan) {
      setUserPrice(selectedPlan?.price * (subscriptionMonths-closedMonths));
      setTotalPrice(selectedPlan?.price * (subscriptionMonths-closedMonths) * seat);
    }
  };



  return (
    <div>
      <Dialog open={openState} onClose={handleClose} >
        {submitState === false ? (
          <DialogTitle>Edit plan</DialogTitle>
        ) : (
          ""
        )}
        <DialogContent>
          <>
            {/* <DialogContentText>
              Reach out to us with a message and we'll respond to you at the
              earliest
            </DialogContentText> */}
            <Divider />
            <Box
              mt={3}
              // component="form"
              // noValidate
              // onSubmit={onCheckoutHandler}
            >
              <Grid container display={"flex"}>
                <Grid display={"flex"} container>
                  <Grid item xs={6} p={1}>
                    {"Choose plan"}
                  </Grid>
                  <Grid item xs={6} p={1}>
                    <FormControl fullWidth>
                      <Select
                        id="demo-simple-select"
                        value={`${plan}`}
                        // label="Plan"
                        onChange={handleChange}
                        name="plans"
                        sx={{ height: "35px" }}
                        // {...supportForm("plan")}
                      >

                        <MenuItem value={19} disabled={19 < previousPlan?.plan}>Standard 10+ users</MenuItem>
                        <MenuItem value={39} disabled={39 < previousPlan?.plan}>Standard 20+ users</MenuItem>
                        <MenuItem value={59} disabled={59 < previousPlan?.plan}>Standard 40+ users</MenuItem>
                        <MenuItem value={79} disabled={79 < previousPlan?.plan}>Standard 60+ users</MenuItem>
                        <MenuItem value={100} disabled={100 < previousPlan?.plan}>Standard 80+ users</MenuItem>

                        <MenuItem
                          value={101}
                          sx={{
                            height: "50px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{ color: "rgba(0, 0, 0, 0.87)" }}
                          >
                            Enterprise
                          </Typography>
                          <Typography variant="body2" sx={{ color: "#8D8D8D" }}>
                            for 100+ users
                          </Typography>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                <Grid display={"flex"} container>
                  <Grid display="flex" alignItems="center" item xs={6} p={1}>
                    {"Total no. of users"}
                  </Grid>
                  <Grid item xs={6} pt={1} pb={1} display={"flex"}>
                    <CustomNumberInput
                      value={seats}
                      aria-label="Quantity Input"
                      min={seatsCxt.availableSeats + 1}
                      max={101}
                      onChange={(_e, val) => handleChangeSeats(val || 0)}
                      // onChange={handleChangeSeats}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Divider textAlign="left" sx={{ m: 2 }}></Divider>

              {seats < 101 ? (
                <>
                  <Grid container display={"flex"}>
                    <Grid display={"flex"} container>
                      <Grid item xs={6} p={1}>
                        {prevSeats>10 ? `Price for additional user (USD)` : "Price per user (USD)"}
                      </Grid>
                      <Grid item xs={6} p={1}>
                        <Box component="div" sx={{ display: "inline" }}>
                          {new Intl.NumberFormat('en-IN', {style: "currency",currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0}).format(userPrice)} 
                        </Box>
                        <Box component="div" sx={{ display: "inline" }}>
                          <Typography sx={{ display: "inline" }}>
                            {" "}
                             {prevSeats>10 && seats>prevSeats ? "until end of subscription period" : "per year"}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    
                    <Grid
                      display={"flex"}
                      container
                      sx={{ fontWeight: "bold" }}
                    >
                      <Grid item xs={6} p={1}>
                        Total Price (USD)
                      </Grid>
                      <Grid item xs={6} p={1}>
                        <Box component="div" sx={{ display: "inline" }}>
                        {prevSeats>10 && seats>prevSeats ? 
                        new Intl.NumberFormat('en-IN', {style: "currency",currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0}).format((seats-prevSeats)*userPrice) : 
                        new Intl.NumberFormat('en-IN', {style: "currency",currency: "USD", minimumFractionDigits: 0, maximumFractionDigits: 0}).format(totalPrice)
                        }
                        </Box>
                        <Box component="div" sx={{ display: "inline" }}>
                          <Typography sx={{ display: "inline" }}>
                            {" "}
                            {prevSeats>10 && seats>prevSeats ? `for ${seats-prevSeats} users` : "per year"}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    

                  </Grid>
                </>
              ) : (
                <>
                  <Grid container display={"flex"} flexDirection={"column"}>
                    <Grid item p={1}>
                      <Typography variant="h6">Looking for an E nterprise plan?</Typography>
                    </Grid>
                    <Grid item p={1}>
                      Unlock custom pricing and features. Contact us for details
                    </Grid>
                  </Grid>

                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <LoadingButton
                      type="submit"
                      variant="contained"
                      loading={isLoading}
                      onClick={upgradeSupportHandler}
                      disabled={!isValid}
                      sx={{
                        mt: 3,
                        mb: 2,
                        width: "250px",
                        bgcolor: "#F47907",
                        fontSize: "12px",
                        "&.Mui-disabled": {
                          background: "#f6d9b9",
                        },
                        "&:hover": {
                          bgcolor: "#FF8D24",
                        },
                      }}
                    >
                      SenseOps Enterprise Enquiry
                    </LoadingButton>
                  </Box>
                </>
              )}

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  onClick={prevSeats<=10 ? onCheckoutHandler : onCheckoutHandler}
                  loading={isLoading}
                  disabled={!isValid || seats >= 101}
                  sx={{
                    mt: 3,
                    mb: 2,
                    width: "200px",
                    bgcolor: "#F47907",
                    fontSize: "12px",
                    "&.Mui-disabled": {
                      background: "#f6d9b9",
                    },
                    "&:hover": {
                      bgcolor: "#FF8D24",
                    },
                  }}
                >
                  Checkout
                </LoadingButton>
              </Box>
            </Box>
          </>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Cart;
